import { alerts } from '../actions/Alerts';
import CONSTANTS from '../constants';
import PromotionsService from '../services/PromotionsService';

export function getPromotions(loc_id, history = {}) {
  return async (dispatch) => {
    try {
      let promotions = await PromotionsService.getPromotions(loc_id);
      dispatch({ type: CONSTANTS.ACTIONS.PROMOTIONS.LIST, promotions });
    } catch (error) {
      console.log('Error: ', error);
      dispatch(alerts.error('PROMOTIONS_NOT_FOUND', error.message));
    }
  };
}

export function checkPromo(code, loc_id, history = {}) {
  return async (dispatch) => {
    try {
      let promotion = await PromotionsService.getPromotionByCodeIfApplicable(code, loc_id);
      dispatch({ type: CONSTANTS.ACTIONS.PROMOTIONS.GET_PROMOTION, promotion });
    } catch (error) {
      console.log('Error: ', error);
      dispatch(alerts.error('PROMOTIONS_NOT_FOUND', error.message));
    }
  };
}
